





























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import LanguageLabel from  "@/models/language/LanguageLabel/languageLabel.model"
import GenericEdit from '@/core/Generics/GenericEdit';
@Component
export default class LanguageLabelEdit extends GenericEdit<LanguageLabel> {
  constructor() {
    super();
    this.controller = 'LanguageLabel';
    this.model = new LanguageLabel();
  }

   saveAll(){
      this.model.languageGroupId = this.$route.params.languageGroupId as any;
      return this.validate();
  }
}
